import { cn } from '@/lib/utils'
import { Skeleton } from '@/components/ui/Feedback'
import { WatchCard } from './WatchCard'
import type { Watch } from '@/types'

/**
 * The one grid used everywhere pieces are listed: 1 column on a phone, 2 on a
 * tablet, 3 on a desktop. Changing the rhythm of the whole site means changing
 * this one line.
 */
export function WatchGrid({
  watches,
  loading = false,
  columns = 3,
  className,
  query = '',
}: {
  watches: Watch[]
  loading?: boolean
  columns?: 3 | 4
  className?: string
  /** Passed down so result cards can mark what matched. */
  query?: string
}) {
  const grid = cn(
    'grid gap-x-6 gap-y-12 sm:gap-x-8 sm:gap-y-14 grid-cols-1 sm:grid-cols-2',
    columns === 3 ? 'lg:grid-cols-3' : 'lg:grid-cols-4',
    className,
  )

  if (loading) {
    return (
      <div className={grid}>
        {Array.from({ length: columns }).map((_, i) => (
          <div key={i} className="flex flex-col gap-4">
            <Skeleton className="aspect-[4/5] w-full" />
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-6 w-40" />
          </div>
        ))}
      </div>
    )
  }

  return (
    <div className={grid} data-upbo-type="container" data-upbo-label="Watch grid">
      {watches.map((w) => (
        <WatchCard key={w.id} watch={w} query={query} />
      ))}
    </div>
  )
}
